import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const MemberList = () => import('@/views/member/MemberList')
const CompanyList = () => import('@/views/member/CompanyList')
const CompanyAuthList = () => import('@/views/member/CompanyAuthList')
const ReportList = () => import('@/views/member/ReportList')
const OrderList = () => import('@/views/order/OrderList')
const OrderProgressList = () => import('@/views/order/OrderProgressList')
const EvaluateList = () => import('@/views/order/EvaluateList')
const OrderTemplateList = () => import('@/views/order/OrderTemplateList')
const OrderCategoryList = () => import('@/views/order/OrderCategoryList')
const ResumeList = () => import('@/views/member/resumeList')
const WalletList = () => import('@/views/wallet/WalletList')
const BonusList = () => import('@/views/wallet/BonusList')
const WithdrawalList = () => import('@/views/wallet/WithdrawalList')
const WalletRedList = () => import('@/views/invite/WalletRedList')
const SignInList = () => import('@/views/invite/SignInList')
const InviteList = () => import('@/views/invite/InviteList')
const InviteConfig = () => import('@/views/invite/InviteConfig')
const TrainingRequestList = () => import('@/views/invite/TrainingRequestList')
const BannerList = () => import('@/views/banner/BannerList')
const BannerClassify = () => import('@/views/banner/BannerClassify')
const ManagerCate = () => import('@/views/manager/ManagerCate')
const ManagerDiy = () => import('@/views/manager/ManagerDiy')
const ManagerSys = () => import('@/views/manager/ManagerSys')
const WeNotify = () => import('@/views/manager/WeNotify')
const SubSite = () => import('@/views/manager/SubSite')
const DataReport = () => import('@/views/manager/DataReport')
const PlatformReport = () => import('@/views/report/PlatformReport')
const DataImport = () => import('@/views/report/DataImport')
const RightsReport = () => import('@/views/report/RightsReport')
const TrendReport = () => import('@/views/report/TrendReport')
const AdminList = () => import('@/views/admin/AdminList')
const AdminRole = () => import('@/views/admin/AdminRole')
const CsChatList = () => import('@/views/chat/CsChatList')
const PeerChatList = () => import('@/views/chat/PeerChatList')

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/dataScreen',
    component: () => import('@/views/dashboard/DataScreen'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: { title: '数据总览', affix: true }
      }
    ]
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/list',
    meta: { title: '用户管理' },
    children: [
      { path: 'list', name: 'MemberList', component: MemberList, meta: { title: '用户管理' } },
      { path: 'resumeList', name: 'ResumeList', component: ResumeList, meta: { title: '务工方' } },
      { path: 'companyList', name: 'CompanyList', component: CompanyList, meta: { title: '用工方' } },
      { path: 'companyAuthList', name: 'CompanyAuthList', component: CompanyAuthList, meta: { title: '雇主认证' } },
      { path: 'reportList', name: 'ReportList', component: ReportList, meta: { title: '举报记录' } }
    ]
  },
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    meta: { title: '订单管理' },
    children: [
      { path: 'list', name: 'OrderList', component: OrderList, meta: { title: '订单审核' } },
      { path: 'categoryList', name: 'OrderCategoryList', component: OrderCategoryList, meta: { title: '工种类目' } },
      { path: 'templateList', name: 'OrderTemplateList', component: OrderTemplateList, meta: { title: '发布模板' } },
      { path: 'orderProgressList', name: 'OrderProgressList', component: OrderProgressList, meta: { title: '订单进度' } },
      { path: 'evaluateList', name: 'EvaluateList', component: EvaluateList, meta: { title: '评价管理' } }
    ]
  },
  {
    path: '/wallet',
    component: Layout,
    redirect: '/wallet/list',
    meta: { title: '钱包管理' },
    children: [
      { path: 'list', name: 'WalletList', component: WalletList, meta: { title: '任务钱包' } },
      { path: 'bonusList', name: 'BonusList', component: BonusList, meta: { title: '奖励金' } },
      { path: 'withdrawalList', name: 'WithdrawalList', component: WithdrawalList, meta: { title: '提现记录' } }
    ]
  },
  {
    path: '/invite',
    component: Layout,
    redirect: '/invite/walletRedList',
    meta: { title: '活动管理' },
    children: [
      { path: 'walletRedList', name: 'WalletRedList', component: WalletRedList, meta: { title: '红包记录' } },
      { path: 'signInList', name: 'SignInList', component: SignInList, meta: { title: '签到记录' } },
      { path: 'list', name: 'InviteList', component: InviteList, meta: { title: '邀请记录' } },
      { path: 'config', name: 'InviteConfig', component: InviteConfig, meta: { title: '红包配置' } },
      { path: 'trainingRequestList', name: 'TrainingRequestList', component: TrainingRequestList, meta: { title: '培训需求' } }
    ]
  },
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/list',
    meta: { title: '广告管理' },
    children: [
      { path: 'list', name: 'BannerList', component: BannerList, meta: { title: '广告列表' } },
      { path: 'classify', name: 'BannerClassify', component: BannerClassify, meta: { title: '广告位分类' } }
    ]
  },
  {
    path: '/manager',
    component: Layout,
    redirect: '/manager/cate',
    meta: { title: '系统管理' },
    children: [
      { path: 'cate', name: 'ManagerCate', component: ManagerCate, meta: { title: '分类管理', superOnly: true } },
      { path: 'diy', name: 'ManagerDiy', component: ManagerDiy, meta: { title: '自定义配置', superOnly: true } },
      { path: 'sys', name: 'ManagerSys', component: ManagerSys, meta: { title: '系统管理', superOnly: true } },
      { path: 'weNotify', name: 'WeNotify', component: WeNotify, meta: { title: '消息通知管理', superOnly: true } },
      { path: 'subSite', name: 'SubSite', component: SubSite, meta: { title: '驿站管理', superOnly: true } },
      { path: 'dataReport', name: 'DataReport', component: DataReport, meta: { title: '数据报表', hidden: true } }
    ]
  },
  {
    path: '/admin',
    component: Layout,
    redirect: '/admin/list',
    meta: { title: '系统管理员', superOnly: true },
    children: [
      { path: 'list', name: 'AdminList', component: AdminList, meta: { title: '管理员设置' } },
      { path: 'role', name: 'AdminRole', component: AdminRole, meta: { title: '角色权限管理' } }
    ]
  },
  {
    path: '/report',
    component: Layout,
    redirect: '/report/platform',
    meta: { title: '数据报表中心' },
    children: [
      { path: 'platform', name: 'PlatformReport', component: PlatformReport, meta: { title: '平台综合报表' } },
      { path: 'import', name: 'DataImport', component: DataImport, meta: { title: '数据归集导入' } },
      { path: 'rights', name: 'RightsReport', component: RightsReport, meta: { title: '维权管理报表' } },
      { path: 'trend', name: 'TrendReport', component: TrendReport, meta: { title: '求职趋势报表' } }
    ]
  },
  {
    path: '/chat',
    component: Layout,
    redirect: '/chat/cs',
    meta: { title: '对话管理' },
    children: [
      { path: 'cs', name: 'CsChatList', component: CsChatList, meta: { title: '零工客服对话' } },
      { path: 'peer', name: 'PeerChatList', component: PeerChatList, meta: { title: '零工雇主对话' } }
    ]
  },
  { path: '*', redirect: '/dashboard', hidden: true }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

// 快速连续点击菜单时忽略「被新导航取消」等无害错误，避免控制台报错
function silenceNavigationFailure(err) {
  if (!err) return false
  const msg = err.message || ''
  return err.name === 'NavigationDuplicated' || msg.includes('Navigation cancelled')
}

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

function wrapNavigationAbort(onReject) {
  return function onAbort(err) {
    if (silenceNavigationFailure(err)) {
      return
    }
    if (onReject) {
      onReject(err)
    }
  }
}

function patchRouterMethod(original) {
  return function patched(location, onResolve, onReject) {
    if (onResolve || onReject) {
      return original.call(this, location, onResolve, wrapNavigationAbort(onReject))
    }
    return original.call(this, location).catch(err => {
      if (silenceNavigationFailure(err)) {
        return err
      }
      return Promise.reject(err)
    })
  }
}

VueRouter.prototype.push = patchRouterMethod(originalPush)
VueRouter.prototype.replace = patchRouterMethod(originalReplace)

export default router
